/**
 * Formats a video duration in seconds into a human-readable string (e.g. "2 minutes 30 seconds")
 * Handles edge cases like rounding to 60 seconds and null/undefined values
 * @param duration The duration in seconds
 * @returns A formatted string or empty string for invalid duration
 */
export const formatVideoDuration = (duration: number | null | undefined): string => {
  if (duration == null || duration < 0) {
    return ''; // Handle null, undefined or negative duration
  }
  
  if (duration === 0) {
    return '0 seconds'; // Handle zero duration
  }
  
  const minutes = Math.floor(duration / 60);
  // Round the seconds to the nearest whole number
  const seconds = Math.round(duration % 60);
  const parts = [];
  
  if (minutes > 0) {
    parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`); // Pluralize 'minute'
  }
  
  // Only include seconds if there are seconds OR if there are no minutes
  if (seconds > 0 || minutes === 0) {
    // Handle edge case where rounding 59.something seconds results in 60
    if (seconds === 60) {
      // If seconds round to 60, increment minutes and don't show seconds
      parts.pop(); // Remove the minutes part added before
      parts.push(`${minutes + 1} minute${minutes + 1 !== 1 ? 's' : ''}`);
    } else {
      parts.push(`${seconds} second${seconds !== 1 ? 's' : ''}`); // Pluralize 'second'
    }
  }
  
  return parts.join(' ');
}; 